import { APP_INITIALIZER, EnvironmentProviders, Provider } from '@angular/core';
import { ConfigService } from './config.service';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { configFactory } from './app-config.initializer';

export const CONFIG_PROVIDERS: (Provider | EnvironmentProviders)[] = [
  provideHttpClient(withInterceptorsFromDi(), withFetch()),
  ConfigService,
  {
    provide: APP_INITIALIZER,
    useFactory: configFactory,
    deps: [ConfigService],
    multi: true,
  },
];
